<template>
    <div class="card">
        <div class="card-header bg-white">
            <div class="row align-items-center">
                <div class="col px-0">
                    <h5 class="me-auto">Precios fijos</h5>
                </div>
                <div class="col-auto">
                    <div class="hstack gap-2 justify-content-end">
                        <button type="button" class="btn btn-h btn-dark" @click="ADD_TEXT('[$product_type]')">
                            <span>Producto</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark" @click="ADD_TEXT('[$value]')">
                            <span>Valor</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark" @click="ADD_TEXT('[$weight]')">
                            <span>Peso</span>
                        </button>
                        <button @click="ADD()" type="button" class="btn btn-h btn-primary">
                            <span><i class="bi bi-plus"></i></span>
                        </button>
                        <button @click="SAVE()" type="button" class="btn btn-h btn-success px-3">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Guardar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body px-0 py-2">
            <v-data-table  class="elevation-1 no-hover"
                :items="data.slice().reverse()"
                hide-default-header
                hide-default-footer>
                <template v-slot:[`item`]="{ item, index }">
                    <tr colspan="100%">
                        <div class="container-fluid py-3" :class="index != 0 ? 'border-top' : ''">
                            <app-switch-if :data="item" :id="index+1" :add_text="add_text" :btn="btn" :set_id="set_id" no_discount @set_id="e => set_id = e" @remove="REMOVE"/>
                        </div>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            data: [],
            count: 0,
            btn: '',
            add_text: 0,
            set_id: '',
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/calculator/fixed/price', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        ADD_TEXT: function(btn){
            let vue = this
            vue.add_text++
            vue.btn = btn
        },
        ADD: function(){
            let vue = this
            let type = 'C'
            vue.data.push(
                {
                    id: vue.data.length+1,
                    type: type,
                    values: [
                        {
                            min: '',
                            operator: '',
                            max: '',
                            condition: '',
                            disabled: false
                        },
                    ],
                    value: '',
                    no_discount: false
                },
            )
        },
        REMOVE: function(id){
            let vue = this
            let index = vue.data.findIndex(e => e.id == id)
            if(index != -1){
                vue.data.splice(index, 1)
            }
        },
        SAVE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/calculator/fixed/price', method: 'POST', data: { fixed_price: vue.data } })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>